import service from './config'
class RescueService {
    rescue(param) {
        return service.post('/api/teammem/rescuebysn',param)
    }  
    MemberRescue(param) {
        return service.post('/api/TeamMember/MemberRescue',param)
    }  
    getRescueBySN(param) {
        return service.get('/api/TeamMember/GetRescueByRsn',param)
    } 
    removeRescue(param) {
        return service.post('/api/TeamMember/RemoveRescue',param)
    } 
    getTeamByFree() {
        return service.get('/api/TeamMember/GetTeamMemberForDispatchArea')
    } 
    
   
     
}
export default new RescueService()